import React from 'react';

const JS_RegExp_Metachars = () => {
  return (
    <div >
      <h1>JS_RegExp_Metachars</h1>
      <p>Placeholder component for: "JS RegExp Metachars"</p>
    </div>
  );
};

export default JS_RegExp_Metachars;
